<template>
  <div class='repeatable'>
    <div class='answer-list'>
      <table>
        <draggable @change='onChange' v-model='localList' tag='tbody'>
          <tr v-for='(item, i) in localList' :key='"answer" + i'>
            <td class='grip-line'><i class='fa fa-grip-lines'></i></td>
            <td class='label'>{{item.label}}</td>
            <td class='action'><a @click.prevent='remove(i)'><i class='fa fa-times'></i></a></td>
          </tr>
        </draggable>
      </table>
    </div>
    <br>
    <!-- <a class='button button-primary' v-if='!adding' @click='add'>Add {{ singular }}</a>
    <div class='add' v-if='adding'> -->
      <field @enter='onEnter("add", $event)' :validate-with="{string:[1,100]}" v-for='(item, key) in template' :key='"repeatable_" + key' :field='item' @change='updateOption(newAnswer, $event)' ref='new_answer' :name='key'></field>
      <a @click.prevent='onEnter("add", $event)' class='add-answer button button-icon-start'><i class='fa fa-plus'></i><span> Add answer</span></a>
    <!-- </div> -->
  </div>
</template>
<script>
import Draggable from 'vuedraggable'
export default {
  props: {
    singular: {
      type: String,
      default: 'Item'
    },
    plural: {
      type: String,
      default: 'Items'
    },
    template: {
      type: Object,
      default: ()=>({})
    },
    list: {
      type: Array,
      default: []
    }
  },
  components: {
    field: () => import('./Field.vue'),
    'draggable': Draggable
  },
  data () {
    return {
      localList: [],
      adding: false,
      newAnswer: {},
      initialised: false
    }
  },
  mounted () {
    this.initialised = true
  },
  methods: {
    focus(){
      this.$refs.new_answer[0].focus()
    },
    onEnter (action, event) {
      let input = this.$refs.new_answer[0]
      if (!input.isValid){
        return false
      }
      input.updateValue(null)
      this.commitAnswer()
    },
    remove (i) {
      this.localList.splice(i,1)
      this.$emit('change', this.localList)
    } ,
    commitAnswer () {
      this.adding = false
      this.localList.push(Object.assign({}, this.newAnswer))
      if (this.initialised === true) {
        this.$emit('change', this.localList)
      }
    },
    onChange () {
      if (this.initialised === true) {
        this.$emit('change', this.localList)
      }
    },
    updateOption(ob, event){
      this.newAnswer = Object.assign({}, {label: event.value, value: event.value, score: 0})
    }
  },
  created () {
    this.localList = this.list
  }
}
</script>
<style scoped lang='scss'>
// @import '../scss/variables';
// @import '../scss/form';
  table {
    table-layout: fixed;
    tr td {
      font-size: 18px;
    }
  }
  td.grip-line, td.action {
    width: 50px;
  }

  td.label {
    width: 70%;
    text-align: left;
  }
  tr {
    cursor: pointer;
  }
  .add-answer {
    margin-top: 1rem;
  }
</style>